<template>
  <div id="p-ide-c" @mousemove="resizeMove" @mouseup="resizeSwitch(false, '')">
      <div class="c-left" :style="{width: resizeWidth + 'px'}">
          <QuestionInfo class="examination-info" v-show="!questionLoadErr">
          </QuestionInfo>
      </div>
      <div class="resize-w-bar" @mousedown="resizeSwitch(true, 'w')">
      </div>
      <div class="c-right">
          <TitleBar v-show="!questionLoadErr"></TitleBar>
          <div v-show="!questionLoadErr" class="work-area">
              <div class="ide-parent">
                  <div class="ide-area" v-loading="isRunLoading">
                      <div v-if="resizeType" class="ide-over"></div>
                      <IdeAce v-if="isLocalIde"></IdeAce>
                      <IdeIframe v-else></IdeIframe>
                  </div>
                  <div class="console-bar" :style="{height: resizeHeight + 'px'}">
                    <div class="resize-switch">
                      <div class="resize-h-bar" @mousedown="resizeSwitch(true, 'h')"></div>
                      <div v-if="false" class="switch-bar">切换主题:
                        <el-switch :width="30" v-model="ideMode" @change="ideModeChange"
                                   active-color="#222222" inactive-color="#efefef">
                        </el-switch>
                      </div>
                    </div>
                    <CmdPanel></CmdPanel>
                  </div>
              </div>
              <PyRuntimeCom :resize-type="resizeType" v-if="isRunLocal && isPyRuntimeCom"></PyRuntimeCom>
              <PythonRunIframe :resize-type="resizeType" v-else-if="isRunLocal"></PythonRunIframe>
          </div>
      </div>
  </div>
</template>

<script type="text/babel">
  /**
   * 考级编程主界面：
   query: {
      user_uid: null, // 用户 UID
      exam_uid: null, // 考试项目 UID
      exam_grade_uid: null, // 考生答卷 UID
      question_uid: null, // 试题 UID
      question_code: null, // 试题编号
      question_score: 0, // 试题分数
      timestamp: 0,
      token: ''
      //https://qceit-kaoji.coding.qq.com/c-judge?problem_id=20772&user_uid=c94b54cc-fce6-4214-9a46-66703dfc1f22
      // &exam_uid=bf69a224-01f4-4cff-a3a2-cd0c13b9631e&exam_grade_uid=17ad8558-50ec-4b80-b0ed-fb52fda1b124
      // &question_uid=df4bdb53-0ea2-4258-8904-01f4a30df54c&question_code=0913-01&question_score=20.00
      // &timestamp=1602728949&token=c896bf20a3fec647a2927303b1fb441c&d=2020-10-15-10-29-10
    },
   */

  import { mapGetters } from 'vuex';
  import QuestionInfo from '@/components/ide/QuestionInfo'
  import TitleBar from '../../components/ide/TitleBar'
  import IdeIframe from '@/components/ide/IdeIframe'
  import IdeAce from '@/components/editor/Ace'
  import PythonRunIframe from '@/components/ide/PythonRunIframe'
  import PyRuntimeCom from '@/components/pyruntime/PyRuntimeCom'
  import CmdPanel from '@/components/ide-c/CCmdPanel'
  import iframe, { setPostOrigin } from '../../scripts/iframe/index'
  import {emitEvent, onEvent} from '../../utils/eventBus/vueEvent'
  import Events from '../../scripts/events/index'
  import Socket from '../../scripts/socket/index'
  import consoleStyle from '../../components/ide/consoleStyle'
  import timer from '../../scripts/timer';
  import HttpRunner from '../../scripts/http-runner';
  import HttpTest from '../../scripts/http-test';

  export default {
    name: 'p-ide-c',
    components: {
      QuestionInfo, IdeIframe, CmdPanel, PythonRunIframe, TitleBar, IdeAce, PyRuntimeCom
    },
    props: {},
    data() {
      return {
        ideMode: false,
        resizeHeight: 216,
        resizeWidth: 360,
        resizeType: '',
        timingSaveInterval: '',
        isRunLoading: false,
      }
    },
    computed: {
      ...mapGetters(['ideCode', 'prevCode', 'language', 'isRunLocal', 'runningData', 'isEdit', 'isLocalIde', 'isPyRuntimeCom', 'questionLoadErr']),
    },
    created() {
      this.initEvent()
      this.initData()
      if (this.$route.query.tls) {
        const num = parseInt(this.$route.query.tls)
        if (num > 300 && num < 600) {
          this.resizeWidth = num
        }
      }
    },
    mounted() {
      this.timingSave()
      // history.pushState(null, null, document.URL)
      // window.addEventListener('popstate', function () {
      //   history.pushState(null, null, document.URL)
      // })
    },
    destroyed() {
      window.onbeforeunload = null
    },
    methods: {
      initEvent() {
        onEvent(Events.YOUTH_SET_CODE, this.getCodeCallBack)
        onEvent(Events.IFRAME_EVENT_BY_VUE, this.onMessage)
        window.onmessage = this.onMessage
      },

      /**
       * iframe 事件侦听;
       * @param e
       */
      onMessage(e) {
        let data = e && e.data;
        if (!data) return;
        if (typeof data === 'string' && data.indexOf('method') > 0) {
          data = JSON.parse(e.data);
        }
        if (!data.method) return;
        switch (data.method) {
          case iframe.CLOSEWINDOWS:
            emitEvent(Events.OUTPUT_CONSOLE, { result: '正在关闭...' })
            if (!this.isEdit) {
              this.closeCallBack({ Code: 0 })
              return
            }
            this.closeHandler(true);
            break;
          case iframe.PYTHON_READY:
            setPostOrigin(e.origin)
            this.$store.dispatch('setSkulptReady', true)
            emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getSuccess(`python运行时初始化完成${data.data || ""}`))
            break;
          case iframe.IDE_READY:
            setPostOrigin(e.origin)
            this.$store.dispatch('setIdeReady', true)
            emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getSuccess(`编辑器初始化完成${data.data || ""}`))
            break;
          case iframe.IDE_EDIT_BLUR:
            if (!this.isEdit) {
              return
            }
            iframe.getIdeCode(iframe.TYPE_CACHE_SAVE, this.isLocalIde);
            break;
          case iframe.IDE_EDIT_CHANGE:
          {
            if (!this.isEdit) {
              return
            }
            const cTime = this.onMessage.cacheTime || 0;
            if (Date.now() - cTime < 5) {
              return;
            }
            this.onMessage.cacheTime = Date.now();
            iframe.getIdeCode(iframe.TYPE_CACHE_SAVE, this.isLocalIde);
          }
            break;
          case iframe.YOUTH_SET_CODE:
            this.getCodeCallBack(data);
            break;
          case iframe.PYTHON_RUN_RES:
            if (!data.data || data.data.Code !== 0) {
              console.error('run res err:', data.data);
              // 提交
              emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getWarn('python运行环境初始化异常，请先保存，再点击"开始编程"重新进入，再次运行') })
            }
            timer.clearTimer(timer.timers.run.key);
            break;
          case iframe.PYTHON_RUN_END:
            this.$store.dispatch('setIsRunning', false)
            if (data.data) {
              emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getRun('...运行结束') })
            } else {
              emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getWarn('...运行错误') })
            }
            break;
          case iframe.YOUTH_OUTPUT:
            if (data.data) {
              data.data = consoleStyle.getOutput(data.data);
            }
            emitEvent(Events.OUTPUT_CONSOLE, data.data);
            break;
          case iframe.YOUTH_GET_INPUT:
            emitEvent(Events.NEED_INPUT);
            break;
          default:
            console.log('- onMessage:', data.method);
            break;
        }
      },

      getCodeCallBack(data) {
        const code = data.data
        if (this.isEdit) {
          const codeMax = 51200;
          if (code && code.length > codeMax) {
            this.$message.error(`代码不能超过${codeMax}个字符:${code.length}`);
            emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getWarn(`代码不能超过${codeMax}个字符:${code.length}`));
            return;
          }
          this.$store.dispatch('setCode', { ideCode: code })
        }
        if (data.type === iframe.TYPE_RUN) {
          if (!code || !code.trim()) {
            console.error('run code is null');
            this.$store.dispatch('setIsRunning', false)
            emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getWarn('代码为空，运行失败'))
            emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getRun('...运行结束') })
            timer.clearTimer(timer.timers.run.key);
            return;
          }
          if (this.isRunLocal) {
            this.$store.dispatch('saveCode', { code, query: this.$route.query, saveType: iframe.TYPE_AUTO_SAVE })
            // if (code && code.indexOf('import turtle') >= 0 && this.resizeWidth < 480) {
            //   this.resizeWidth = 480
            // }
            emitEvent(Events.RUN_PYTHON_CODE_LOCAL, code);
          } else {
            if (HttpRunner.isHttp()) {
              HttpRunner.run(code, this.$route.query, this.language.value, this.isEdit);
            } else {
              Socket.runCode(code, this.$route.query, this.language.value, this.isEdit);
            }
          }
        } else if (data.type === iframe.TYPE_TEST || data.type === iframe.TYPE_TEST_HTTP) {
          if (!code || !code.trim()) {
            this.$store.dispatch('setIsTesting', false);
            emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getWarn('代码为空，测试不通过'))
            emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getTest('...测试结束') })
            timer.clearTimer(timer.timers.test.key);
            return;
          }
          if (HttpTest.isHttp()) {
            HttpTest.test(code, this.$route.query, this.language.ojVal, this.isEdit);
          } else {
            Socket.testCode(code, this.$route.query, this.language.ojVal, this.isEdit);
          }
        } else if (data.type === iframe.TYPE_SAVE) {
          this.$store.dispatch('saveCode', { code, query: this.$route.query, saveType: data.type })
        }  else if (data.type === iframe.TYPE_AUTO_SAVE) {
          if (code) {
            this.$store.dispatch('saveCode', { code, query: this.$route.query, saveType: data.type })
          }
        } else if (data.type === iframe.TYPE_COMMIT) {
          emitEvent(Events.OUTPUT_CONSOLE, { result: '....' })
          this.$store.dispatch('commitCode', { code, query: this.$route.query, callback: this.closeCallBack })
        } else if (data.type === iframe.TYPE_CACHE_SAVE) {
          this.$store.dispatch('saveCodeLocal', { code, query: this.$route.query, saveType: data.type })
        } else if (data.type === iframe.TYPE_CLOSE_SAVE) {
          this.$store.dispatch('commitCode', { code, query: this.$route.query, callback: this.closeCallBack })
        }
      },

      closeHandler(isComfirm) {
        if (this.ideCode && this.ideCode.trim()) {
          if (isComfirm) {
            // 提交
            emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSave('代码保存中...') })
            iframe.getIdeCode(iframe.TYPE_CLOSE_SAVE, this.isLocalIde);
          } else {
            // 提交
            this.$confirm('关闭前是否保存代码？', '温馨提示', {
              // 提交
              confirmButtonText: '保存',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              console.lgo('do commit');
              this.closeHandler(true);
            }).catch(() => {
              console.lgo('dont commit');
            });
          }
        } else {
          this.closeCallBack({ Code: 0 })
        }
      },

      closeCallBack(res) {
        const obj = {
          method: 'saveComplete',
          data: res && res.Code === 0 ? 'success' : 'error',
          message: ''
        }
        window.parent.postMessage(JSON.stringify(obj), '*')
      },

      // 编辑器模版修改
      ideModeChange() {
        console.log('ideModeChange:', JSON.stringify(arguments), this.ideMode);
        iframe.setIdeTheme(this.ideMode ? 1 : 0, this.isLocalIde);
      },

      /**
       * 初始化数据
       */
      async initData() {
        HttpRunner.init(this, false);
        HttpTest.init(this, true);
        // 设置context,以便store中可以实用$message,应用vue实例；
        this.$store.dispatch('setContext', this)

        // set code language etc:
        this.$store.dispatch('initQuery', this.$route.query)
        this.$store.dispatch('getQuestionInfo', this.$route.query)

        // 实际运行未进行请求
        this.$store.dispatch('getExamInfo', { query: this.$route.query, ifLoad: false })
        this.$store.dispatch('getAnswerList', this.$route.query)
        this.$store.dispatch('getNewestCode', this.$route.query)
      },

      saveCode() {
        iframe.getIdeCode(iframe.TYPE_AUTO_SAVE, this.isLocalIde);
      },

      // 定时保存到服务器redis
      timingSave() {
        if (this.isEdit) {
          console.log('timingSave start ...')
          this.timingSaveInterval = setInterval(() => {
            this.saveCode()
          }, 60000)
        }
      },

      // 调整窗口大小
      resizeSwitch(tag, type) {
        // console.log('resizeSwitch:', tag, type);
        this.resizeType = type
      },
      resizeMove() {
        // console.log('resizeMove:', this.resizeType);
        if (this.resizeType) {
          if (this.resizeType === 'w') {
            this.resizeWidth = event.clientX
          } else {
            this.resizeHeight = window.innerHeight - event.clientY
          }
        }
      },
    }
  }
</script>
<style lang="scss">
    @import "../../assets/scss/base/variables";

    #p-ide-c {
        display: flex;
        flex-grow: 1;
        flex-direction: row;
        height: 100%;

        .c-left {
            width: 360px;
            min-width: 200px;
            display: flex;
            flex-direction: column;
        }

        .resize-w-bar {
            width: 11px;
            flex-grow: 0;
            cursor: col-resize;
            z-index: 10;
            height: 100%;
            background-color: #ddd;
            background-image: url(../../assets/images/exam/resizex.png);
            background-repeat: no-repeat;
            background-position: center;
            border-left: 1px solid #b4b4b4;
            border-right: 1px solid #b4b4b4;
        }

        .c-right {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            min-width: 500px;

            .work-area {
                flex-grow: 1;
                display: flex;
                flex-direction: row;
            }

            .ide-parent {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
            }

            .ide-area {
                flex-grow: 1;
                background-color: $c-bg-white;
                display: flex;
                flex-direction: column;
                position: relative;

                .ide-over {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(255,255,255,0.01);
                }

                .c-ace-editor {
                    flex-grow: 1;
                }
            }

            .console-bar {
                height: 216px;
                min-height: 100px;
                flex-grow: 0;
                background-color: $c-bg-white;
                display: flex;
                flex-direction: column;
                position: relative;

                .resize-switch {
                    display: flex;
                    flex-direction: row;
                }

                .resize-h-bar {
                    height: 11px;
                    flex-grow: 1;
                    cursor: row-resize;
                    z-index: 10;
                    background-color: #ddd;
                    background-image: url(../../assets/images/exam/resizey.png);
                    background-repeat: no-repeat;
                    background-position: center;
                    border-top: 1px solid #b4b4b4;
                    border-bottom: 1px solid #b4b4b4;
                }

                .switch-bar {
                    background-color: #ddd;
                    border-bottom: 1px solid #b4b4b4;
                    border-right: 1px solid #b4b4b4;
                    border-left: 1px solid #b4b4b4;
                    padding: 1px 5px 0 5px;
                    color: #000;
                    font-size: 12px;
                }

                .el-switch {
                    &__core {
                        height: 14px;
                    }
                    &__core:after {
                        height: 10px;
                        width: 10px;
                        background-color: #000;
                    }
                }
                .el-switch.is-checked .el-switch__core::after {
                    margin-left: -12px;
                    background-color: #fff;
                }
            }
        }
    }
</style>
